/* eslint-disable @typescript-eslint/no-explicit-any */
import { injectable } from 'inversify';

import {
  CommentSearchData,
  ContentSearchRequest,
  ContentSearchResponse,
  NewsSearchData,
} from '@app/gen/search';

const DEFAULT_LIMIT_CATEGORY_ITEM = 3;
const DEFAULT_LIMIT_SINGLE_CATEGORY = 6;

@injectable()
export class LayoutMapper {
  processSearchItems(
    response: ContentSearchResponse,
    group: ContentSearchRequest['group'],
  ) {
    const newsTitle = {
      id: 'news',
      type: 'label' as const,
      label: 'Новости',
      total: response.news.total,
    };

    const news = response.news.items
      .map((item: NewsSearchData) => ({
        ...item,
        type: 'news' as const,
      }))
      .slice(0, DEFAULT_LIMIT_SINGLE_CATEGORY);

    const commentTitle = {
      id: 'comment',
      type: 'label' as const,
      label: 'Комментарии',
      total: response.comments.total,
    };

    const comments = response.comments.items
      .map((item: CommentSearchData) => ({
        ...item,
        type: 'comment' as const,
      }))
      .slice(0, DEFAULT_LIMIT_SINGLE_CATEGORY);

    if (group === 'news') {
      return news.length ? [newsTitle, ...news] : [];
    }
    if (group === 'comments') {
      return comments.length ? [commentTitle, ...comments] : [];
    }

    return [
      ...(news.length
        ? [newsTitle, ...news.slice(0, DEFAULT_LIMIT_CATEGORY_ITEM)]
        : []),
      ...(comments.length
        ? [commentTitle, ...comments.slice(0, DEFAULT_LIMIT_CATEGORY_ITEM)]
        : []),
    ];
  }
}
